<div class="commission-update-package-view-container" *ngIf="commissionUpdatePackageObject" fxLayout="column"
     fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <button [disabled]="!(userPermissions | async).settlement.write" (click)="modify()" mat-stroked-button
              color="primary">
        <mat-icon>create</mat-icon>
        <span> Edytuj</span>
      </button>
      <div fxFlex>

      </div>
      <button [disabled]="!(userPermissions | async).settlement.write || commissionUpdatePackageObject?.rows.length > 0 "
              (click)="delete()"
              mat-stroked-button
              color="warn">
        <mat-icon>delete</mat-icon>
        <span> Usuń</span>
      </button>

    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>

        <app-detail header="TU" [value]="commissionUpdatePackageObject.insuranceCompany?.name"></app-detail>

        <app-detail header="Importer" [value]="commissionUpdatePackageObject.importer?.name"></app-detail>

        <app-detail header="Firma" [value]="commissionUpdatePackageObject.company?.name"></app-detail>
        <app-detail header="Partner" [value]="commissionUpdatePackageObject.partner?.shortName"></app-detail>
        <app-detail header="Ofwca" [value]="commissionUpdatePackageObject.ofwca?.fullName"></app-detail>


        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <app-detail header="Kod ryzyka" [value]="commissionUpdatePackageObject.riskCode"></app-detail>
          </div>
          <div fxFlex="50">
            <app-detail header="Kod grupy" [value]="commissionUpdatePackageObject.riskPack"></app-detail>
          </div>
        </div>
        <ng-container *ngFor="let risk of commissionUpdatePackageObject.risks; let i = index">
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="33">
              <app-detail header="Ryzyko ASF">
                <mat-chip-list>
                  <mat-chip color="primary" selected>{{ risk?.risk.name }}</mat-chip>
                </mat-chip-list>
              </app-detail>
            </div>
            <div fxFlex="33">
              <app-detail header="Stawka % TU" [value]="risk.importRate"></app-detail>
            </div>
            <div fxFlex="33">
              <app-detail header="Stawka % Partner" [value]="risk.ratePaid"></app-detail>
            </div>
          </div>
        </ng-container>

        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center" style="padding: 10px 0;">
          <app-detail-bool fxFlex="50" header="Pakiet"
                           [value]="commissionUpdatePackageObject.isPackage"></app-detail-bool>
          <app-detail-bool fxFlex="50" header="Aktywny "
                           [value]="commissionUpdatePackageObject.active"></app-detail-bool>
        </div>
      </mat-card>
    </div>

  </div>

</div>
